import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { ApiRoutes } from '@sb/library/api';
import { UtilityModule } from '@sb/library/utility';

@Component({
    selector: 'lib-svg',
    standalone: true,
    imports: [UtilityModule],
    templateUrl: './svg.component.html'
})
export class SvgComponent {

    private readonly _ChangeDetector = inject(ChangeDetectorRef);

    private static _nextSvgInstanceId: number = 0;
    private readonly _svgInstanceId: number = ++SvgComponent._nextSvgInstanceId;

    @Input() alt: string = '';

    @Input() src: string = '';
    @Input()
    set height(value: number) {
        this._height = value;

        if (this._svgContentInitial) {
            this._svgContent = this.SetSvgHeight(this._svgContentInitial);
        }
    }

    private _svgContent: string = '';
    private _svgContentInitial: string = '';
    private _height: number = 225;

    ngAfterViewInit(): void {
        this.FetchSvgContent(this.src);
    }

    private FetchSvgContent(src: string): void {
        ApiRoutes.Assets.Images.Get.Call({Parameter: src}).subscribe((response: string) => {
            this._svgContentInitial = this.MakeSvgIdsUnique(response);
            this._svgContent = this.SetSvgHeight(this._svgContentInitial);
            this._ChangeDetector.detectChanges();
        });
    }

    private MakeSvgIdsUnique(svgSource: string): string {
        // Inline SVG IDs share the document namespace, so give each instance its own IDs.
        const idMap = new Map<string, string>();
        const uniqueSvgSource = svgSource.replace(/(\s+id\s*=\s*)(["'])([^"']+)\2/g, (_match: string, prefix: string, quote: string, id: string) => {
            const uniqueId = `sb-svg-${this._svgInstanceId}-${id}`;
            idMap.set(id, uniqueId);
            return `${prefix}${quote}${uniqueId}${quote}`;
        });

        // Rewrite local fragment references to point to this instance's renamed unique instance definitions
        return uniqueSvgSource
            .replace(/url\(\s*(["']?)#([^)'"\s]+)\1\s*\)/g, (match: string, quote: string, id: string) => {
                const uniqueId = idMap.get(id);
                return uniqueId ? `url(${quote}#${uniqueId}${quote})` : match;
            });
    }

    private SetSvgHeight(svgSource: string): string {
        return svgSource.replace(/<svg\b([^>]*)>/i, (_fullMatch: string, attrs: string) => {
            return `<svg${attrs} height="${this.height}">`;
        });
    }

    get svgContent(): string {
        return this._svgContent;
    }

    get height(): number {
        return this._height;
    }
}
